var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-btn',{staticClass:"full-width ",attrs:{"name":"form-back","color":"primary","disable":_vm.disable,"label":_vm.title},on:{"click":_vm.clickForm}})}
var staticRenderFns = []

export { render, staticRenderFns }